import { useQuery } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

import { useBrandAccountId } from '../useBrandAccountId'

import { useMainQueryKey } from './useMainQueryKey'

const document = graphql(`
  query TimeSeriesSettingsPage_Main($brandAccountId: ID!) {
    brandAccount(brandAccountId: $brandAccountId) {
      id
      surveyGroups {
        id
        title
        alertSurveys
        surveys {
          id
          title
          metadata {
            surveyStartDate {
              year
              month
              day
            }
          }
        }
        brands {
          id
          name
          attachedBrands {
            surveyId
            brandId
          }
        }
        questions {
          id
          name
          showCustomizedKPI
          attachedQuestions {
            surveyId
            questionId
          }
          options {
            id
            text
            attachedOptions {
              surveyId
              option
            }
          }
        }
        customerAttributeGroups {
          id
          name
          showCustomizedKPI
          attachedCustomerAttributeGroups {
            surveyId
            customerAttributeGroupId
          }
          customerAttributes {
            id
            name
            attachedCustomerAttributes {
              surveyId
              customerAttributeId
            }
          }
        }
      }
      surveys(questionDisplayFilter: DETAIL_COUNT) {
        id
        title

        brandGroups {
          id
          brands {
            id
            name
          }
        }
        questions {
          question_id
          question_text
          mt_questions
          answer_options {
            option
            text
          }
        }
        customerAttributeGroups {
          id
          name
          customerAttributes {
            id
            name
          }
        }
        metadata {
          surveyStartDate {
            year
            month
            day
          }
        }
      }
    }
  }
`)

export const useMainQuery = () => {
  const graphQLRequest = useGraphQLRequest()
  const brandAccountId = useBrandAccountId()
  const queryKey = useMainQueryKey()

  return useQuery({
    queryFn: () => graphQLRequest({ document, variables: { brandAccountId } }),
    queryKey,
  })
}
